// extracted by mini-css-extract-plugin
export default {"info":"editable-data_info__mMxCm"};